export default __webpack_public_path__ + "static/media/Banner.172ed7f5.jpg";